<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<loading :active="loading">
					<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
				</loading>
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Nueva solicitud</h4>
				</div>
				<div class="modal-body">
					<template v-if="forms">
						<template v-if="forms.length">
							<div class="row">
								<div class="col-md-12">
									<div class="form-group" :class="{ 'has-error' : errors.has('form_id') }">
										<label class="control-label">Formulario</label>
										<select
											v-validate="'required'"
											name="form_id"
											data-vv-as="Solicitud"
											v-model="data.form_id"
											class="form-control">
											<option v-for="form in forms" :value="form.id">
												{{ form.name }}
											</option>
										</select>
										<small v-show="errors.has('form_id')" class="form-text text-danger">
											{{ errors.first('form_id') }}
										</small>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group" :class="{ 'has-error' : errors.has('title') }">
										<label class="control-label">Título</label>
										<input
											v-validate="'required'"
											name="title"
											data-vv-as="Título"
											v-model="data.title"
											type="text"
											class="form-control">
										<small v-show="errors.has('title')" class="form-text text-danger">
											{{ errors.first('title') }}
										</small>
									</div>
								</div>
							</div>
						</template>
					</template>
				</div>
				<div class="modal-footer">
					<button @click="validate" ref="btnStore" type="submit" class="btn btn-success">
						Guardar
					</button>
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth', 'fast'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'requests-create-' + new Date().getTime(),
				},
				loading: false,

				forms: null,
				model: null,
				type: null,

				data: {
					title: null,
					form_id: null,
					customer_id: null,
					request_status_id: 1,
				}
			}
		},
		methods: {
			open(model, type) {
				this.clearData()
				this.getForms()
				if(model) {
					this.model = model
				}
				if(type) {
					this.type = type
				}
				if(this.type == 'customer') {
					this.data.customer_id = this.model.id
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.errors.clear()
				this.forms = null
				this.model = null
				this.type = null

				this.data.title = null
				this.data.form_id = null
				this.data.customer_id = null
				this.data.request_status_id = 1
			},
			getForms() {
				this.loading = true
				this.$http.get('admin/forms')
				.then(response => {
					this.loading = false
					this.forms = response.body
					this.loadForm()
					this.fasterMode()
				}).catch(function(response) {
					console.log(response)
					this.loading = false
				})
			},
			init() {
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					return result
				})
			},
			store () {
				this.loading = true
				this.$http.post('admin/requests', this.data)
				.then(response => {
					this.close()
					this.$emit('reload')
					this.$emit('openEditRequest', response.body.data)
					this.loading = false
				}).catch(function(response) {
					console.log(response)
					this.close()
					this.$emit('reload')
					this.loading = false
					if(response.status == 409) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}
				})
			},
			loadForm() {
				if(this.forms) {
					if(this.forms.length) {
						if(this.forms.length == 1) {
							this.data.title = this.forms[0].name
							this.data.form_id = this.forms[0].id
						}
					}
				}
			},
			fasterMode() {
				if(this.fast) {
					this.store()
				}
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/requests/views/Create.vue